<app-cc-detail-dialog [formConfig]="detailFormConfig" [transPartKey]="transPartKey"
                      [formRecord]="formRecord" [(dialogFormVisible)]="detailDialogVisible"
                      [dialogFormTitle]="'page.clearing.order.table.zoom_clearing' | translate">
</app-cc-detail-dialog>
